import { MainCoverage } from "../../models/main-coverage";
import {
    MAIN_COVERAGE_SUB_COVERAGES,
    MAIN_COVERAGE_CODE,
    ASSISTANT_PACKAGE_CODE,
    ASSISTANT_PACKAGE_SUB_COVERAGES,
    COVERAGES_CODES_TRADUCTION,
    COVERAGES_ORDER,
    FIXED_COVERAGES_LIST,
} from "../../constants/coverages";
import { AssistantPackage } from "../../models/assistant-package";
import { Coverage } from "../../models/coverage";
import { PaymentFee } from "../../models/payment-fee";
import {
    URBANIZATION_TYPES,
    STREETS_TYPES,
    ABBREVIATION_STREETS_TYPES_LABELS,
    STREETS_TYPES_LABELS,
    URBANIZATION_TYPES_LABELS,
} from "../../constants/addresses";
import { AddressInfo } from "../../models/address-info";


export const mapEstimatedResponseToCoverages = estimatedResponse => {
    const { additionsSelected = [] } = estimatedResponse;
    const {
        amount: mainCoveragePrice,
        amountMonthly: mainCoverageMonthlyPrice,
    } = additionsSelected.find(
        ({ additionalGroup }) => additionalGroup === MAIN_COVERAGE_CODE
    );
    const mainCoverage = new MainCoverage({
        price: mainCoveragePrice,
        monthlyPrice: mainCoverageMonthlyPrice,
        coverages: MAIN_COVERAGE_SUB_COVERAGES,
    });
    const {
        amount: assistantPackagePrice,
        amountMonthly: assistantPackageMonthlyPrice,
    } = additionsSelected.find(
        ({ additionalGroup }) => additionalGroup === ASSISTANT_PACKAGE_CODE
    );
    const assistantPackage = new AssistantPackage({
        price: assistantPackagePrice,
        monthlyPrice: assistantPackageMonthlyPrice,
        coverages: ASSISTANT_PACKAGE_SUB_COVERAGES,
    });
    const fixedCoverages = additionsSelected
        .filter(
            ({ additionalGroup }) => FIXED_COVERAGES_LIST.indexOf(additionalGroup) >= 0
        )
        .map(
            ({ amount, amountMonthly, additionalGroup }) =>
                new Coverage({
                    id: additionalGroup,
                    name: COVERAGES_CODES_TRADUCTION[additionalGroup],
                    price: amount,
                    monthlyPrice: amountMonthly,
                    code: additionalGroup,
                })
        );
    const optionalCoverages = additionsSelected
        .filter(
            ({ additionalGroup }) =>
                additionalGroup !== MAIN_COVERAGE_CODE &&
                // additionalGroup !== ASSISTANT_PACKAGE_CODE &&
                FIXED_COVERAGES_LIST.indexOf(additionalGroup) < 0
        )
        .sort(
            (cob1, cob2) =>
                COVERAGES_ORDER[cob1.additionalGroup] -
                COVERAGES_ORDER[cob2.additionalGroup]
        )
        .map(
            ({ amount, amountMonthly, additionalGroup }) =>
                new Coverage({
                    id: additionalGroup,
                    name: COVERAGES_CODES_TRADUCTION[additionalGroup],
                    price: amount,
                    monthlyPrice: amountMonthly,
                    code: additionalGroup,
                })
        );
    return {
        mainCoverage,
        assistantPackage,
        coverages: optionalCoverages,
        fixedCoverages,
        belongingsInsuranceHasMinPrime: estimatedResponse.primeMinBelongings || false,
        propertyInsuranceHasMinPrime: estimatedResponse.primeMinProperty || false,
    };
};

export const mapHomeInsuraceStateToEstimatedSelectionsRequest = homeInsuranceState => {
    const { quotation } = homeInsuranceState;
    const selectedCoveragesCodes = [MAIN_COVERAGE_CODE];
    if (quotation.assistantPackage) {
        selectedCoveragesCodes.push(ASSISTANT_PACKAGE_CODE);
    }
    selectedCoveragesCodes.push(...quotation.selectedCoverages.map(cov => cov.code));
    return selectedCoveragesCodes;
};



export const mapCardResumeAddress = ({
    streetType,
    streetName,
    streetNumber,
    interiorNumber,
    block,
    lotNumber,
    urbanizationType,
    urbanizationName,
}) => {
    let address = "";
    streetName = streetName.trim();
    streetNumber = streetNumber.trim();
    interiorNumber = interiorNumber.trim();
    block = block.trim();
    lotNumber = lotNumber.trim();
    urbanizationType = urbanizationType.trim();
    urbanizationName = urbanizationName.trim();
    if (
        STREETS_TYPES_LABELS[streetType] !== STREETS_TYPES_LABELS[STREETS_TYPES.NO_TYPE]
    ) {
        address += `${ABBREVIATION_STREETS_TYPES_LABELS[streetType]} ${streetName} `;
        address += streetNumber !== "" ? ` ${streetNumber} ` : "";
    }
    address += interiorNumber !== "" ? `Dpto. ${interiorNumber} ` : "";
    address += block !== "" ? `Mz. ${block} ` : "";
    address += lotNumber !== "" ? `Lt. ${lotNumber} ` : "";
    if (
        URBANIZATION_TYPES_LABELS[urbanizationType] !==
        URBANIZATION_TYPES_LABELS[URBANIZATION_TYPES.NO_TYPE]
    ) {
        address += `${URBANIZATION_TYPES_LABELS[urbanizationType]} ${urbanizationName}`;
    }
    return address;
};

export const mapAddressInfoRequest = (payload = new AddressInfo()) => {
    const { streetType, urbanizationType, basements } = payload;
    return {
        ...payload,
        streetName: streetType === STREETS_TYPES.NO_TYPE ? "" : payload.streetName,
        urbanizationName:
            urbanizationType === URBANIZATION_TYPES.NO_TYPE
                ? ""
                : payload.urbanizationName,
        streetNumber: streetType === STREETS_TYPES.NO_TYPE ? "" : payload.streetNumber,
        basements: basements === "" ? "0" : basements,
    };
};

export const mapSaveSelectedCoveragesResponseToPriceAndFees = saveSelectedCoveragesResp => {
    return {
        primeTotal: saveSelectedCoveragesResp.primeTotal,
        primeTotalDiscount: saveSelectedCoveragesResp.primeTotalDiscount,
        paymentFees: saveSelectedCoveragesResp.listQuoteDetails
            .map(
                quoteDetail =>
                    new PaymentFee({
                        code: quoteDetail.planCode,
                        label: `${quoteDetail.quote} cuota${quoteDetail.quote === 1 ? "" : "s"
                            }`,
                        price: quoteDetail.amount,
                        priceWithDiscount: quoteDetail.amountDiscount,
                        quantity: quoteDetail.quote,
                    })
            )
            .sort((q1, q2) => q1.quantity - q2.quantity),
    };
};
